import LocalSeoPage from '@/pages/local/components/LocalSeoPage';
import { aracruzCelulose } from '@/mocks/localSeoData';

export default function RecuperacaoEquipamentosCeluloseAracruz() {
  return <LocalSeoPage data={aracruzCelulose} />;
}